import type { ClientAdminsStressAssessmentResult } from '@fukuri-admins/apis/client/gen/model';
import { useState } from 'react';
import { StressAssessmentProfilePresentation } from './presentations';

type Props = {
  result: ClientAdminsStressAssessmentResult;
};

export const StressAssessmentProfile: React.FC<Props> = ({ result }) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  return (
    <StressAssessmentProfilePresentation
      result={result}
      selectedIndex={selectedIndex}
      onSelectIndex={setSelectedIndex}
    />
  );
};
